import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-white to-green-100 py-12 text-[#1B3D1B]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Responsive Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-y-12 gap-x-6 text-center">
          {/* LOGO */}
          <div>
            <Link to="/" className="text-[28px] font-semibold">
              MedTag
            </Link>
          </div>

          {/* COMPANY */}
          <div>
            <h3 className="font-semibold mb-2">COMPANY</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="#">Privacy policy</Link>
              </li>
              <li>
                <Link to="#">Terms of Services</Link>
              </li>
            </ul>
          </div>

          {/* PRODUCT */}
          <div>
            <h3 className="font-semibold mb-2">PRODUCT</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="membership">Pricing</Link>
              </li>
            </ul>
          </div>

          {/* DOWNLOAD */}
          <div>
            <h3 className="font-semibold mb-2">DOWNLOAD</h3>
            <img
              src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://medtag.app"
              alt="QR Code"
              className="w-20 h-20 mx-auto"
            />
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="text-center text-xs text-gray-400 mt-10">
          &copy; Copyright 2024. All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
